"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dispatch_custom_event_1 = require("../dispatch-custom-event");
function eventNamespaceFactory(namespace) {
    return function (element, eventName) {
        return dispatch_custom_event_1.default(element, eventName + '.' + namespace);
    };
}
exports.default = eventNamespaceFactory;
